import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const LabworkAttachmentsModalContext = createContext<ContextType | null>(null);

const LabworkAttachmentsModalProvider: ComponentWithChildren = ({
  children,
}) => {
  const providerValue = useProviderValue();

  return (
    <LabworkAttachmentsModalContext.Provider value={providerValue}>
      {children}
    </LabworkAttachmentsModalContext.Provider>
  );
};

export const useLabworkAttachmentsModalContext = () => {
  const context = useContext(LabworkAttachmentsModalContext);
  if (context === undefined) {
    throw new Error(
      'the useLabworkAttachmentsModalContext should be used within LabworkAttachmentsModalProvider!'
    );
  }

  return context;
};

export default LabworkAttachmentsModalProvider;
